module.exports = __webpack_public_path__ + "img/nextArrowAnimation.6fd34e17.svg";